import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Button, Empty } from "antd";
import { CSVLink } from "react-csv";
import CanvasJSReact from "../../lib/canvasjs/canvasjs.react";
import LoadingContent from "../loading/LoadingContent";
import Switch from "../../component/switch/Index";
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Container = styled.section`
  border: 1px solid lightgray;
  padding: 10px 5px;
  position: relative;

  .desc-text {
    position: absolute;
    left: 10px;
    top: 20px;
    padding: 5px 10px;
    z-index: 9;
    font-weight: bold;
  }

  .visible-control {
    position: absolute;
    left: 10px;
    top: 50px;
    padding: 5px 10px;
    z-index: 9;
    font-weight: bold;
    display: flex;
  }
  .checkbox-item {
    display: flex;
    align-items: center;
    margin-right: 10px;
    span {
      margin-left: 4px;
    }
  }
  .btn-ctl {
    margin: 0px 2px;
    transform: translateY(-4px);
  }

  .canvas-graph__toggle-zoom-wrapper {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    a {
      margin-right: 3px;
    }
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -1px;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background-color: #fff;
    z-index: 999;
  }
`;

const Loading = styled(LoadingContent)`
  height: 10px !important;
`;

export default function LineGraphCanvasJs(props) {
  const email = useSelector((state) => state.acc.email);
  const [csvData, setCsvData] = useState([]);
  const [toggleZoom, setToggleZoom] = useState(false);
  const [max, setMax] = useState(0);
  const [visibleLegend, setVisibleLegend] = useState([]);
  const [addOnMax, setAddOnMax] = useState(0);
  const [graph, setGraph] = useState(
    <Empty description="ไม่พบข้อมูลที่จะแสดง" />
  );

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    zoomType: "x",
    toolTip: {
      shared: true,
    },
    title: {
      text: props.title,
    },
    subtitles: props?.subtitles ? props.subtitles : [],
    axisY: {
      title: "",
      suffix: "",
      gridThickness: 1,
      gridColor: "lightgray",
      labelFormatter: function (e) {
        return e.value.toFixed(2);
      }
    },
    axisX: {
      gridColor: "lightgray",
    },
    legend: {
      fontSize: 16,
      cursor: "pointer",
      itemclick: (e) => {
        if (props.toggleVisible) {
          props.toggleVisible(e.dataSeries.name, !e.dataSeries.visible);
          setAddOnMax(0);
        }
        e.chart.render();
      },
    },
    data: [],
  };

  const renderCsvData = (data) => {
    let procData = [];
    let loopData = props.data.map((s, i) => {
      s.dataPoints.map((d) => {
        if (i < 1) procData.push({ date: d.label });
        let m = procData.find((pd) => pd.date == d.label);
        if (m) m[s.name] = d.y;
      });
    });
    setCsvData(procData);
  };

  const colors = [
    "#0080ff",
    "#ff0000",
    "#ff8000",
    "#ffff00",
    "#80ff00",
    "#00ff00",
    "#00ff80",
    "#00ffff",
    "#8000ff",
    "#ff00ff",
    "#ff0080",
  ];

  const colorsWater = ["#0000ff", "#fc0313", "#80ff00", "#8000ff", "#ff00ff"];

  const getLineColor = (name, idx, ii) => {
    if (props.randomLineColor) {
      return colors[ii] ? colors[ii] : "lightgray";
    } else {
      if (name.indexOf("น้ำ") >= 0)
        return colorsWater[idx] ? colorsWater[idx] : "blue";
      if (name.indexOf("แบต") >= 0) return "orange";
    }
    return "red";
  };

  const renderMaxY = (data) => {
    let newMax = 0;
    data.map((item, i) => {
      if (item.onGraph) {
        let dataMax = Math.max.apply(
          Math,
          item.dataPoints.map(function (o) {
            return o.y;
          })
        );
        if (dataMax > newMax) newMax = dataMax;
      }
    });

    setMax(newMax + addOnMax);
  };

  useEffect(() => {
    let concat = [];
    let concatData = [];

    if (props.data) {
      if (props.rendering) {
        setAddOnMax(0);
      }

      renderCsvData(props.data);

      const prodData = props.data;
      let waters = [];
      // const prodData = props.data.filter((item) => item.onGraph);
      prodData.map((item, i) => {
        if (item.name.indexOf("น้ำ") >= 0) {
          waters.push(item);
        }
        concat.push({
          name: item.name,
          type: "line",
          yValueFormatString:"#######.00",
          color: getLineColor(item.name, waters.length - 1, i),
          lineThickness: null,
          markerType: "circle",
          markerSize: 5,
          visible: props.data[i].onGraph,
          showInLegend: true,
          dataPoints: item.dataPoints,
        });

        renderMaxY(prodData);
        // if( visibleLegend.indexOf(item.name) < 0){
        concatData.push(item.dataPoints);
        // }
      });

      setGraph(
        <CanvasJSChart
          options={{
            ...options,
            zoomEnabled: toggleZoom,
            data: concat,
            axisY: { ...options.axisY, maximum: max * 1.2 },
          }}
        />
      );

      if (props.rendering) {
        if (document.querySelector(".canvasjs-chart-toolbar") !== null) {
          if (
            document.querySelector(
              '.canvasjs-chart-toolbar button[state="reset"]'
            )
          ) {
            document
              .querySelector('.canvasjs-chart-toolbar button[state="reset"]')
              .click();
          }
        }
      }
    }
  }, [
    props.data,
    props.rendering,
    props.subtitles,
    toggleZoom,
    addOnMax,
    max,
    visibleLegend,
  ]);

  return (
    <Container>
      <div className="canvas-graph__toggle-zoom-wrapper">
        {email && (
          <CSVLink data={csvData} filename={props.title + ".csv"}>
            <Button className={"btn-primary"}>CSV</Button>
          </CSVLink>
        )}
        {/* <div className="desc-text">ค่าระดับน้ำวัดเทียบจากศูนย์บรรทัดน้ำ</div> */}
        <div className="visible-control">
          <button
            className="btn-ctl btn btn-primary"
            onClick={() => {
              setAddOnMax(addOnMax + 0.5);
            }}
          >
            UP
          </button>
          <button
            className="btn-ctl btn btn-primary"
            onClick={() => {
              setAddOnMax(addOnMax - 0.5);
            }}
          >
            DOWN
          </button>
          <button
            className="btn-ctl btn btn-primary"
            onClick={() => {
              setAddOnMax(0);
            }}
          >
            RESET
          </button>
        </div>
        <Switch
          className={"canvas-graph__toggle-zoom"}
          checkedChildren="เปิดซูม"
          unCheckedChildren="ปิดซูม"
          checked={toggleZoom}
          onChange={() => {
            setToggleZoom(!toggleZoom);
          }}
        />
      </div>
      {graph}
      {props.loading ? (
        <div className="loading">
          <Loading className="graph-loading" />
        </div>
      ) : (
        ""
      )}
      {props.rendering ? (
        <div className="loading">
          <Loading className="graph-loading" />
        </div>
      ) : (
        ""
      )}
    </Container>
  );
}
